import { toolHref as href, routeForPath as route, type ToolRoute } from '../core/tool-registry.js';
export const APP_BASE = import.meta.env.BASE_URL;
export const toolHref = (tool: ToolRoute) => href(tool, APP_BASE);
export const routeForPath = (pathname: string) => route(pathname, APP_BASE);
